export enum ContentAccessType{
    None = 0,
    DavidIcke = 1,
    Unlimited = 2,
    OneDevice = 3,
    TwoDevices = 4,
    FourDevices = 5,
    TruthSeeker = 6,
    GameChanger = 7
}